export const BRAND_NAME = 'CorBet247';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'corbet247.com';
export const PROVIDER_ID = 'BetFair';
